import { render, staticRenderFns } from "./RoundOutcomeFilter.vue?vue&type=template&id=b0b81560&scoped=true&"
import script from "./RoundOutcomeFilter.vue?vue&type=script&lang=js&"
export * from "./RoundOutcomeFilter.vue?vue&type=script&lang=js&"
import style0 from "./RoundOutcomeFilter.vue?vue&type=style&index=0&id=b0b81560&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b81560",
  null
  
)

export default component.exports